/*
 * 订单状态
 *  0未支付 1已支付
 * */
export const OrderState = {
  cancel: "-3",
  all: "-1",
  wait: "0",
  success: "1",
  refund: "2",
  refunding: "4",
  rebate: "5",
};
export const OrderStateLabel = {
  "-3": "已取消",
  "-1": "全部",
  0: "待支付",
  1: "已支付",
  2: "已退款",
  3: "已取消",
  4: "退款中",
  5: "部分退款",
};

/*
 * 订单类型
 *  1试用 2订购 3续费 4升级
 * */

export const OrderType = {
  all: "-1",
  free: "0",
  trial: "1",
  buy: "2",
  renew: "3",
  upgrade: "4",
};
export const OrderTypeLabel = {
  "-1": "全部",
  0: "免费",
  1: "试用",
  2: "订购",
  3: "续费",
  4: "升级",
};

/*
 * 结算状态
 *  0未结算 1已结算
 * */

export const OrderCloseState = {
  all: "-1",
  unClose: "0",
  closed: "1",
};
export const OrderCloseStateLabel = {
  "-1": "全部",
  0: "未结算",
  1: "已结算",
};

/*
 * 退款状态
 * -1全部 1待审核 2已通过 3已驳回
 * */
export const RefundState = {
  all: "-1",
  approving: "1",
  pass: "2",
  fail: "3",
  cancel: "4",
};
export const RefundStateLabel = {
  "-1": "全部",
  1: "待审核",
  2: "已通过",
  3: "已驳回",
  4: "已取消",
};
/*
 * 退款类型
 *  1无理由 2其他
 * */
export const RefundReasonState = {
  noReason: "1",
  other: "2",
};
export const RefundReasonStateLabel = {
  1: "无理由",
  2: "其他",
};

/*
 * 退款日志操作状态
 * -1全部 1提交审核 2审核通过  3审核拒绝
 * */
export const RefundOperateState = {
  all: "-1",
  approving: "1",
  pass: "2",
  fail: "3",
};
export const RefundOperateStateLabel = {
  "-1": "全部",
  1: "提交审核",
  2: "审核通过",
  3: "审核拒绝",
};

/**
 * 提交人角色（退款协商历史）
 */
export const RefundTypeLabel = {
  1: "提交人",
  2: "审核人",
};

/*
 * 企业保证金审核状态
 * 1待审核 2已通过 3已驳回 4已撤回
 * */
export const CoDepositAuditState = {
  all: "-1",
  approving: "1",
  success: "2",
  fail: "3",
  revoke: "4",
};
export const CoDepositAuditStateLabel = {
  "-1": "全部",
  1: "待审核",
  2: "已通过",
  3: "已驳回",
  4: "已撤回",
};

// 分账审批状态
export const SplitAuditState = {
  0: "审批中",
  1: "已通过",
  2: "已驳回",
  3: "已撤回",
};

// 分账审批类型
export const SplitAuditStateType = {
  1: "对公账户", //已通过
};

// 订单对账状态
export const OriginStatementState = {
  0: "未对账",
  1: "已对账",
  2: "异常",
  3: "部分对账",
};

// 对账状态颜色
export const OriginStatementColor = {
  0: "#c6c6c6", //"未对账"
  1: "#41c500", //"已对账"
  2: "#F56C6C", //"异常"
  3: "#9dd782", //"部分对账"
};

// 订单类型
export const BillOrderType = {
  1: "支付",
  2: "退款",
};

// 订单对账状态
export const BillStatementState = {
  0: "未对账",
  1: "已对账",
  2: "部分对账",
};

// 对账状态颜色
export const BillStatementColor = {
  0: "#c6c6c6", //未对账
  1: "#41c500", //已对账
  2: "#9dd782", //部分对账
};

export const PayMethods = {
  "-1": "-",
  0: "微信小程序",
  1: "支付宝小程序",
  2: "App支付宝",
  3: "苹果支付",
  4: "银联云闪付",
  5: "H5支付宝支付",
  6: "扫码支付",
  7: "银联网页支付",
};

export const ErrorType = {
  1: "银行少账", // 银行少账  YHSZ
  2: "金额不等", // 金额不等  JEBD
  3: "银行多账", // 银行多账  YHDZ
  4: "重复付款", // 重复付款  CFFK
  5: "状态存疑", // 状态存疑  ZTCY
  6: "支付成功支付时间为空", // 支付成功支付时间为空  PayDateNull
};

export const ErrorHandlerStatus = {
  1: "已处理", //  Processed ,
  2: "未处理", //  Untreated ,
  3: "自动处理", //  Auto
};

// payway 支付方式
export const PayWay = {
  "01": "现金",
  "02": "刷卡（银行卡）",
  "03": "预付卡",
  "04": "抵用券",
  "05": "支票",
  "06": "积分",
  94: "银联二维码",
  95: "账户快捷",
  96: "账户余额",
  97: "微信",
  98: "支付宝",
  99: "其它",
};

// 发票类型
export const InvoiceType = {
  1: "增值税普通发票",
  2: "增值税专用发票",
};

export const InvoiceState = {
  notApply: 0, // "未申请开票",
  pending: 1, // "待处理",
  doing: 2, // "开票中",
  done: 3, // "已开票",
  cancel: 4, // "已开票",
};

export const InvoiceStateLabel = {
  0: "未申请开票",
  1: "待处理",
  2: "开票中",
  3: "已开票",
  4: "已撤销",
};

export const OpenInvoiceType = {
  electron: 1,
  paper: 2,
};

export const OpenInvoiceTypeLabel = {
  1: "电子发票",
  2: "纸质发票",
  3: "电子发票、纸质发票",
};
export const GroupType = {
  "-1": "全部",
  1: "员工",
  2: "部门",
  3: "企业",
  4: "应用",
  5: "产品",
};
export const GroupTypeLabel = {
  1: "员工",
  2: "部门",
  3: "企业",
  4: "应用",
  5: "产品",
};
// 事件订阅启用类型
export const IsStart = {
  0: "否",
  1: "是",
};
